import { loyaltyPromotionSchema } from "@redotech/redo-loyalty-common/loyalty-definition";
import * as z from "zod/v4";

export const deleteLoyaltyPromotion = {
  name: "deleteLoyaltyPromotion" as const,
  input: z.object({ promotionId: z.string() }),
  output: loyaltyPromotionSchema,
};
